const PAGE_NAMES = {
  HOME: 'course_home',
  IN_COURSE: 'in_course',
  PROGRESS: 'progress',
};

export default PAGE_NAMES;
